module.exports = __webpack_public_path__ + "img/points.379fffc2.png";